<template>
    <div class="container_view">
        <v-card class="content_card" elevation="10" variant="flat">
            <div>
                <header>
                    <v-card-title> Base de Datos 2.0 </v-card-title>
                    <v-divider class="mx-3"></v-divider>
                </header>
            </div>

            <div class="content_accion">
                <div class="d-flex align-center">
                    <v-btn
                        variant="flat"
                        color="indigo-darken-3"
                        class="text-none"
                        prepend-icon="mdi-plus"
                        text="Nueva carga"
                        @click="$router.push('/SGCCV/database/imports/scl')"
                    ></v-btn>
                </div>
                <div class="d-flex align-center">
                    <v-btn icon variant="text" :loading="loading" @click="loadImports(false)">
                        <v-icon>mdi-refresh</v-icon>
                    </v-btn>
                </div>
            </div>

            <v-alert v-if="loadError" type="warning" variant="tonal" class="mx-5 mb-3" density="compact">
                {{ loadError }} <a class="ml-2" @click="loadImports(false)">Reintentar</a>
            </v-alert>

            <div class="container_table">
                <v-data-table
                    class="content_table"
                    :headers="headers"
                    :items="items"
                    :loading="loading"
                    no-data-text="No hay cargas registradas"
                >
                    <template v-slot:[`item.originalFilename`]="{ item }">
                        <a class="link_row" @click="openDetail(item)">{{ item.originalFilename }}</a>
                    </template>
                    <template v-slot:[`item.status`]="{ item }">
                        <v-chip :color="statusInfo(item.status).color" size="small">
                            {{ statusInfo(item.status).label }}
                        </v-chip>
                    </template>
                    <template v-slot:[`item.stage`]="{ item }">
                        <div class="stage_cell">
                            <span>{{ stageLabel(item) }}</span>
                            <span class="text-caption text-grey-darken-1">
                                Actualizado {{ isTerminal(item.status) ? formatDate(item.lastUpdateAt) : (updateAge(item, now) || '-') }}
                            </span>
                        </div>
                    </template>
                    <template v-slot:[`item.progress`]="{ item }">
                        <div class="progress_cell">
                            <div class="progress_row">
                                <div class="progress_bar">
                                    <v-progress-linear :model-value="item.progress" color="indigo-darken-3" height="8"></v-progress-linear>
                                </div>
                                <span class="progress_percent">{{ item.progress }}%</span>
                            </div>
                            <span class="text-caption text-grey-darken-1">{{ item.completedSteps }} / {{ item.totalSteps }} pasos</span>
                        </div>
                    </template>
                    <template v-slot:[`item.eta`]="{ item }">
                        <span v-if="remainingTime(item, now)">~{{ remainingTime(item, now) }}</span>
                        <span v-else class="text-grey-darken-1">{{ remainingTimeStatus(item, now) }}</span>
                    </template>
                    <template v-slot:[`item.processedRows`]="{ item }">
                        {{ item.processedRows }} / {{ item.totalRows }}
                    </template>
                    <template v-slot:[`item.createdAt`]="{ item }">
                        {{ formatDate(item.createdAt) }}
                    </template>
                </v-data-table>
            </div>
        </v-card>

    </div>
</template>

<script>
    import { DatabaseService } from '@/services/DatabaseService';
    import { statusInfo, isTerminal } from './importStatus';
    import { stageLabel, remainingTime, remainingTimeStatus, updateAge } from './importProgress';
    import moment from 'moment';

    export default {
        name: 'ImportTrackingView',
        data () {
            return {
                loading: false,
                fetching: false,
                loadError: '',
                items: [],
                pollTimer: null,
                clockTimer: null,
                now: Date.now(),
                headers: [
                    { title: 'Archivo', value: 'originalFilename' },
                    { title: 'Tipo', value: 'importType' },
                    { title: 'Estado', value: 'status' },
                    { title: 'Etapa actual', value: 'stage', sortable: false, width: '230px' },
                    { title: 'Progreso', value: 'progress', width: '210px' },
                    { title: 'Tiempo restante', value: 'eta', sortable: false, width: '130px' },
                    { title: 'Procesadas', value: 'processedRows' },
                    { title: 'Éxitosas', value: 'successfulRows' },
                    { title: 'Fallidas', value: 'failedRows' },
                    { title: 'Creado', value: 'createdAt' },
                ],
            };
        },
        created () {
            this.loadImports(false);
            this.startPolling();
            this.clockTimer = setInterval(() => { this.now = Date.now(); }, 1000);
        },
        beforeUnmount () {
            this.stopPolling();
            if (this.clockTimer) clearInterval(this.clockTimer);
        },
        methods: {
            loadImports (silent) {
                if (this.fetching) return;
                this.fetching = true;
                if (!silent) {
                    this.loading = true;
                }

                DatabaseService.listImports()
                    .then((resp) => {
                        if (!resp.error) {
                            this.items = resp.response || [];
                            this.loadError = '';
                        } else {
                            this.loadError = 'No se pudo cargar el seguimiento. Intenta de nuevo.';
                        }
                    })
                    .catch(() => {
                        this.loadError = 'La consulta tardó demasiado o el servidor no respondió. Intenta de nuevo.';
                    })
                    .finally(() => {
                        this.fetching = false;
                        if (!silent) this.loading = false;
                    });
            },
            startPolling () {
                this.stopPolling();
                this.pollTimer = setInterval(() => {
                    this.loadImports(true);
                }, 3000);
            },
            stopPolling () {
                if (this.pollTimer) {
                    clearInterval(this.pollTimer);
                    this.pollTimer = null;
                }
            },
            openDetail (item) {
                this.$router.push(`/SGCCV/database/imports/${item.id}`);
            },
            statusInfo (status) {
                return statusInfo(status);
            },
            stageLabel,
            remainingTime,
            remainingTimeStatus,
            updateAge,
            isTerminal (status) {
                return isTerminal(status);
            },
            formatDate (value) {
                return value ? moment(value).format('DD/MM/YYYY HH:mm') : '-';
            },
        },
    };
</script>

<style scoped>
    .content_accion {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 16px 20px;
    }

    .container_table {
        padding: 0 20px 20px;
    }

    .content_table {
        overflow: auto;
    }

    .link_row {
        cursor: pointer;
        color: #1a237e;
        font-weight: 500;
    }

    .stage_cell {
        min-width: 190px;
        display: flex;
        flex-direction: column;
        gap: 4px;
        padding: 5px 0;
    }

    .progress_cell {
        min-width: 180px;
        display: flex;
        flex-direction: column;
        gap: 4px;
        padding: 5px 0;
    }

    .progress_row {
        display: grid;
        grid-template-columns: minmax(0, 1fr) 40px;
        align-items: center;
        column-gap: 16px;
    }

    .progress_bar {
        min-width: 0;
        width: 100%;
    }

    .progress_percent {
        text-align: right;
        font-variant-numeric: tabular-nums;
    }
</style>
